<div class="sidenav-container" *ngIf="islogin">
    <mat-nav-list>
        <a mat-list-item *ngIf="sideBarData['App Builder']?.['resources']?.['Home']" (click)="navigateToPage('home')">
            <mat-icon class="pt-1">home</mat-icon>
            <span class="p-2" matLine>Home</span>
        </a>
    </mat-nav-list>
    <ng-container *ngIf="sideBarData['User Management']">
        <mat-accordion class="sidemenu-accordion"> 
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon>person</mat-icon>
                        User Management
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="panel-buttons" [class.show]="panelOpenState">

                    <mat-nav-list>
                        <ng-container *ngFor="let label of sideConfig?.applications| keyvalue">
                            <a mat-list-item permissions [resourceName]="label.key" location="sideMenu"
                                [ngClass]="{active: checkForActiveRoute(selectedModule, label.value.path)}"
                                routerLinkActive="active" (click)="naviagateTo(label.value.route)">
                                <i matPrefix [class]="label.value.icon"></i>

                                <span class="p-2" matLine>{{label.value.name}}</span></a>
                        </ng-container>

                    </mat-nav-list>

                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </ng-container>
</div>